import LotCard from "@/components/LotCard";
import { useShippingEnrichment } from "@/lib/extension";

const SKELETON_KEYS = ["sk-1", "sk-2", "sk-3", "sk-4", "sk-5", "sk-6", "sk-7", "sk-8"];

function Skeleton() {
  return (
    <div className="space-y-4">
      <div className="aspect-[4/5] skeleton" />
      <div className="h-4 w-3/4 skeleton" />
      <div className="h-3 w-1/2 skeleton" />
    </div>
  );
}

export default function LotGrid({ items, loading, pickupMode = false }) {
  const { merge } = useShippingEnrichment(loading ? [] : items);
  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-10 lg:gap-12" data-testid="lot-grid-skeleton">
        {SKELETON_KEYS.map((k) => (
          <Skeleton key={k} />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-10 lg:gap-12" data-testid="lot-grid">
      {items.map((lot, idx) => (
        <div
          key={lot.id}
          className="animate-fade-up"
          style={{ animationDelay: `${Math.min(idx * 40, 600)}ms` }}
        >
          <LotCard lot={merge(lot)} pickupMode={pickupMode} />
        </div>
      ))}
    </div>
  );
}
